module.exports = __webpack_public_path__ + "static/media/stihl-pro-jardim.61da2797.jpg";